import { useGetCmsTheme } from "@/api/cms";
import { useCmsPageThemeForm } from "@/hooks/use-cms-page-theme-form";
import {
  normalizePageAppearance,
  resolvePageAppearanceStyle,
} from "@/lib/cms-puck/blocks/appearance";
import { CSSProperties, ReactNode } from "react";

/**
 * Applique la couleur de texte de la page (réglage « Couleur des textes ») à
 * l'aperçu Sélection, comme sur le front public (scope `--cms-page-fg`). Sans
 * ce scope, l'aperçu BO n'héritait d'aucune couleur de page et les légendes
 * restaient sur leurs couleurs par défaut. Se met à jour en direct via le
 * formulaire (useCmsPageThemeForm lit avec form.watch).
 */
export function SelectionPreviewThemeScope({
  children,
}: {
  children: ReactNode;
}) {
  const { data: theme } = useGetCmsTheme();
  const {
    pageBackgroundColorId,
    pageTextColorMode,
    pageTextColorId,
    pageFontFamily,
    pageFontVariant,
  } = useCmsPageThemeForm();

  const style = resolvePageAppearanceStyle(
    theme ?? null,
    normalizePageAppearance({
      pageBackgroundColorId,
      pageTextColorMode,
      pageTextColorId,
      pageFontFamily,
      pageFontVariant,
    }),
  );

  return (
    <div
      className="cms-page-theme-scope rounded-md p-4"
      style={
        {
          backgroundColor: style.backgroundColor,
          color: style.color,
          "--cms-page-bg": style.backgroundColor,
          "--cms-page-fg": style.color,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
}
